// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1s0gp","inputWrap":"CustomTip_inputWrap__xdO2C"};